// use for company and company user ???

import ModelEntity from "../model-entity"
import {EntityType} from "../../gd/const/item"
import ModelProxy from "../model-proxy"

const DEFAULT_WORK_DAY = 8*60 //8 hours

const debug = false
// const debug = "WorkWeekSchedule"

export default class WorkWeekSchedule extends ModelEntity {

    public parentEntityType     : EntityType

    public mondayDuration       : number
    public tuesdayDuration      : number
    public wednesdayDuration    : number
    public thursdayDuration     : number
    public fridayDuration       : number
    public saturdayDuration     : number
    public sundayDuration       : number

    constructor(parentEntityType: EntityType, monday:number, tuesday:number, wednesday:number, thursday:number, friday:number, saturday:number, sunday:number) {
        super('workWeekSchedule', EntityType.DYNAMIC_MODEL)

        debug && console.log(debug, 'constructor', this)

        this.parentEntityType   = parentEntityType

        this.mondayDuration     = monday
        this.tuesdayDuration    = tuesday
        this.wednesdayDuration  = wednesday
        this.thursdayDuration   = thursday
        this.fridayDuration     = friday
        this.saturdayDuration   = saturday
        this.sundayDuration     = sunday

        return new Proxy(this, ModelProxy)
    }

    get hasSingleWorkDay() {
        return _.filter(this.toArray(), value => !_.isNil(value) && value > 0).length <= 1
    }

    get hasWorkDays() {
        return _.sum(this.toArray()) > 0
    }

    get isMondayWorking():boolean {
        return this.mondayDuration > 0
    }

    set isMondayWorking(value:boolean) {
        this.mondayDuration = value ? this.getDefaultValue(0) : 0
        this.updatedFields.add('mondayDuration')
    }

    get isTuesdayWorking():boolean {
        return this.tuesdayDuration > 0
    }

    set isTuesdayWorking(value:boolean) {
        this.tuesdayDuration = value ? this.getDefaultValue(1) : 0
        this.updatedFields.add('tuesdayDuration')
    }

    get isWednesdayWorking():boolean {
        return this.wednesdayDuration > 0
    }

    set isWednesdayWorking(value:boolean) {
        this.wednesdayDuration = value ? this.getDefaultValue(2) : 0
        this.updatedFields.add('wednesdayDuration')
    }

    get isThursdayWorking():boolean {
        return this.thursdayDuration > 0
    }

    set isThursdayWorking(value:boolean) {
        this.thursdayDuration = value ? this.getDefaultValue(3) : 0
        this.updatedFields.add('thursdayDuration')
    }

    get isFridayWorking():boolean {
        return this.fridayDuration > 0
    }

    set isFridayWorking(value:boolean) {
        this.fridayDuration = value ? this.getDefaultValue(4) : 0
        this.updatedFields.add('fridayDuration')
    }

    get isSaturdayWorking():boolean {
        return this.saturdayDuration > 0
    }

    set isSaturdayWorking(value:boolean) {
        this.saturdayDuration = value ? this.getDefaultValue(5) : 0
        this.updatedFields.add('saturdayDuration')
    }

    get isSundayWorking():boolean {
        return this.sundayDuration > 0
    }

    set isSundayWorking(value:boolean) {
        this.sundayDuration = value ? this.getDefaultValue(6) : 0
        this.updatedFields.add('sundayDuration')
    }

    get apiCallParams() {
        const params: any = {}

        _.map([...this.updatedFields], (updatedFieldId: string) => {
            switch (updatedFieldId) {
                case 'mondayDuration'       : params.mondayDuration     = this.mondayDuration; break
                case 'tuesdayDuration'      : params.tuesdayDuration    = this.tuesdayDuration; break
                case 'wednesdayDuration'    : params.wednesdayDuration  = this.wednesdayDuration; break
                case 'thursdayDuration'     : params.thursdayDuration   = this.thursdayDuration; break
                case 'fridayDuration'       : params.fridayDuration     = this.fridayDuration; break
                case 'saturdayDuration'     : params.saturdayDuration   = this.saturdayDuration; break
                case 'sundayDuration'       : params.sundayDuration     = this.sundayDuration; break
            }
        })

        return params
    }

    getDuration(isoWeekDay: number):number {
        switch (isoWeekDay) {

            case 2  : return this.tuesdayDuration
            case 3  : return this.wednesdayDuration
            case 4  : return this.thursdayDuration
            case 5  : return this.fridayDuration
            case 6  : return this.saturdayDuration
            case 7  : return this.sundayDuration

            case 1  :
            default :
                return this.mondayDuration
        }
    }

    clearUpdatedFields() {
        this.updatedFields.clear()
    }

    getDefaultValue = (index: number) => {
        switch (this.parentEntityType) {
            case EntityType.COMPANY_USER    : return gd.company.settings.workSchedule.workdayDurations[index] || DEFAULT_WORK_DAY
            case EntityType.COMPANY         :
            default                         : return DEFAULT_WORK_DAY
        }
    }

    reset() {
        switch (this.parentEntityType) {
            case EntityType.COMPANY_USER    :
                this.mondayDuration     = gd.company.settings.workSchedule.workdayDurations[0]
                this.tuesdayDuration    = gd.company.settings.workSchedule.workdayDurations[1]
                this.wednesdayDuration  = gd.company.settings.workSchedule.workdayDurations[2]
                this.thursdayDuration   = gd.company.settings.workSchedule.workdayDurations[3]
                this.fridayDuration     = gd.company.settings.workSchedule.workdayDurations[4]
                this.saturdayDuration   = gd.company.settings.workSchedule.workdayDurations[5]
                this.sundayDuration     = gd.company.settings.workSchedule.workdayDurations[6]
                break

            case EntityType.COMPANY         :
            default                         :
                this.mondayDuration     = DEFAULT_WORK_DAY
                this.tuesdayDuration    = DEFAULT_WORK_DAY
                this.wednesdayDuration  = DEFAULT_WORK_DAY
                this.thursdayDuration   = DEFAULT_WORK_DAY
                this.fridayDuration     = DEFAULT_WORK_DAY
                this.saturdayDuration   = 0
                this.sundayDuration     = 0
        }
    }

    toArray() {
        return [
            this.mondayDuration,
            this.tuesdayDuration,
            this.wednesdayDuration,
            this.thursdayDuration,
            this.fridayDuration,
            this.saturdayDuration,
            this.sundayDuration,
        ]
    }
}